module.exports = __webpack_public_path__ + "img/bank-card.069f8104.svg";